import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TransparentBgButton, SecondaryButton } from 'components/Shared/Button'
import Input from 'components/Shared/Input'

const splitFileName = (fileName = '') => {
  const trimmedFileName = fileName.trim()
  const lastDotIndex = trimmedFileName.lastIndexOf('.')

  // Keep hidden extension only for regular "name.ext" files.
  if (lastDotIndex <= 0 || lastDotIndex === trimmedFileName.length - 1) {
    return { baseName: trimmedFileName, extension: '' }
  }

  return {
    baseName: trimmedFileName.slice(0, lastDotIndex),
    extension: trimmedFileName.slice(lastDotIndex + 1),
  }
}

export default function RenameModal({ image, onClose, onSave, isLoading = false }) {
  const { t } = useTranslation()
  const { baseName, extension } = useMemo(() => splitFileName(image?.name || ''), [image?.name])
  const [newName, setNewName] = useState(baseName)

  useEffect(() => {
    setNewName(baseName)
  }, [baseName])

  const handleSave = () => {
    const trimmedName = newName.trim()

    if (!trimmedName || isLoading) {
      return
    }

    onSave(extension ? `${trimmedName}.${extension}` : trimmedName)
  }

  return (
    <div className="rename-modal-content">
      <div className="rename-modal__content">
        <Input
          placeholder={t('Library.renameModal.placeholder')}
          value={newName}
          name="newName"
          onChange={(e) => setNewName(e.target.value)}
        />
        

        <div className="buttons-container">
          <TransparentBgButton
            text={t('common.cancel')}
            onClick={onClose}
            color="navy"
            fullWidth={false}
            disabled={isLoading}
          />

          <SecondaryButton
            text={t('common.save')}
            onClick={handleSave}
            color="navy"
            fullWidth={false}
            loading={isLoading}
            disabled={!newName.trim()}
          /> 
        </div>
      </div>
    </div>
  )
}